import { useEffect, useState } from 'react';

export type FontSize = 'small' | 'medium' | 'large' | 'x-large';

const FONT_SIZE_KEY = 'app-font-size';

export const useFontSize = () => {
  const [fontSize, setFontSizeState] = useState<FontSize>(() => {
    const saved = localStorage.getItem(FONT_SIZE_KEY);
    return (saved as FontSize) || 'medium';
  });

  useEffect(() => {
    // Apply font size to document root
    document.documentElement.setAttribute('data-font-size', fontSize);
  }, [fontSize]);

  const setFontSize = (size: FontSize) => {
    setFontSizeState(size);
    localStorage.setItem(FONT_SIZE_KEY, size);
    document.documentElement.setAttribute('data-font-size', size);
  };

  return { fontSize, setFontSize };
};
